// Local Regexs

// prettier-ignore
const emailValidRegexInternal = new RegExp('^[a-zA-Z0-9_.+\\-]+@[a-zA-Z0-9\\-]+\\.([a-zA-Z0-9\\-]+\\.)?[a-zA-Z]{2,}$');

// Backend Regexs
let emailValidRegexBE: RegExp | string | undefined = undefined;

export const Validations = {
	get emailValidRegex() {
		return emailValidRegexBE || emailValidRegexInternal;
	},
	set emailValidRegex(value) {
		value && ((value) => (emailValidRegexBE = value))(value);
	},
};
